import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  Checkbox,
  ListItemText,
} from "@mui/material";

const Tags = ({
  tags,
  selectedTags,
  setSelectedTags,
  label = "Tags",
  sx = {},
}) => {
  const isSelected = (tag) => {
    return selectedTags.some((t) => String(t.id) === String(tag.id));
  };

  const handleToggleTag = (tag) => {
    setSelectedTags((prevSelected) => {
      const exists = prevSelected.some((t) => String(t.id) === String(tag.id));
      if (exists) {
        return prevSelected.filter((t) => String(t.id) !== String(tag.id));
      } else {
        return [...prevSelected, tag];
      }
    });
  };

  return (
    <FormControl fullWidth sx={{ mb: 2, ...sx }}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={selectedTags.map((t) => String(t.id))} // convert to strings
        renderValue={() => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selectedTags.map((tag) => (
              <Chip key={tag.id} label={tag.tag_name} />
            ))}
          </Box>
        )}
      >
        {tags?.map((tag) => (
          <MenuItem
            key={tag.id}
            value={String(tag.id)}
            onClick={() => handleToggleTag(tag)}
          >
            <Checkbox checked={isSelected(tag)} />
            <ListItemText primary={tag.tag_name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Tags;
